export default {"src":"/_next/static/media/gray-heart-iconNew.ab08e774.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};